import React from 'react'
import './styles.css'

import Helmet from 'react-helmet'
import Title from '../components/Title'
import NavBar from '../components/NavBar'
import HeaderCaseDeSucesso from '../components/HeaderCaseDeSucesso'
import Footer2 from '../components/Footer2'


const PageCaseDeSucesso = () => {
    return ( 
        <div className='pageStyle2'>
            <Helmet >
                <Title />                 
            </Helmet>
            <NavBar/>
            <HeaderCaseDeSucesso/>
            <Footer2/>
        </div>
    )
}
export default PageCaseDeSucesso